import { createFileRoute, notFound } from "@tanstack/react-router";
import { BenefitsPage } from "./-components/BenefitsPage";
import { profileConfigs } from "./-config";
import { setProfileSubPageBodyColors } from "./-utils/profileHost";

export const Route = createFileRoute("/profile/benefits")({
    component: BenefitsRoute,
    beforeLoad: ({ search }) => {
        if (!profileConfigs[search.tenant].benefits) {
            throw notFound();
        }

        setProfileSubPageBodyColors(
            "var(--color-background-discover-primary)",
            "var(--color-background-discover-tertiary)",
        );
    },
    head: ({ match }) => ({
        meta: [{ title: `Benefits - ${match.search.tenant} ${match.search.locale}` }],
    }),
});

function BenefitsRoute() {
    const { tenant } = Route.useSearch();
    const sections = profileConfigs[tenant].benefits?.sections ?? [];

    return <BenefitsPage tenant={tenant} sections={sections} />;
}
